export const MapSerializer = () => {
  const geocoderDeserializer = (response) => {
    if (response.data.features.length === 0) {
      return {
        center: [],
        geometry: [],
      };
    }

    return {
      center: response.data.features[0].center,
      geometry: response.data.features[0].geometry,
    };
  };

  return Object.freeze({
    geocoderDeserializer,
  });
};
